import { render, staticRenderFns } from "./tcustbase-add-or-update.vue?vue&type=template&id=0e363ea0&scoped=true&"
import script from "./tcustbase-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tcustbase-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase-add-or-update.vue?vue&type=style&index=0&id=0e363ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e363ea0",
  null
  
)

export default component.exports